export const FACEBOOK_IMAGE_MAXIMUM_SIZE = 1000000;
export const FACEBOOK_IMAGE_MINIMUM_SIZE = 1;
export const FACEBOOK_IMAGE_MIN_WIDTH = 200;
export const FACEBOOK_IMAGE_MIN_HEIGHT = 200;


